import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import Homework1 from './components/Homework1';
import Homework2 from './components/Homework2';
import Homework3 from './components/Homework3';
import Homework3Question1 from './components/Homework3Question1';
import Homework3Question2 from './components/Homework3Question2';
import Homework3Question3 from './components/Homework3Question3';
import Homework3Question4 from './components/Homework3Question4';
import Homework4 from './components/Homework4';
import Homework4Question1 from './components/Homework4Question1';
import Homework4Question2 from './components/Homework4Question2';
import Homework5 from './components/Homework5';
import Homework5Question1 from './components/Homework5Question1';
import Homework5Question2 from './components/Homework5Question2';
import Homework6 from './components/Homework6';
// import Homework6Main from './components/Homework6Main';
import Homework7 from './components/Homework7';
import Homework7Main from './components/Homework7Main';
import Homework8 from './components/Homework8';
import Homework9 from './components/Homework9';
import ComingSoon from './components/ComingSoon';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/homework/1" element={<Homework1 />} />
          <Route path="/homework/2" element={<Homework2 />} />
          <Route path="/homework/3" element={<Homework3 />} />
          <Route path="/homework/3/question1" element={<Homework3Question1 />} />
          <Route path="/homework/3/question2" element={<Homework3Question2 />} />
          <Route path="/homework/3/question3" element={<Homework3Question3 />} />
          <Route path="/homework/3/question4" element={<Homework3Question4 />} />
          <Route path="/homework/4" element={<Homework4 />} />
          <Route path="/homework/4/question1" element={<Homework4Question1 />} />
          <Route path="/homework/4/question2" element={<Homework4Question2 />} />
          <Route path="/homework/5" element={<Homework5 />} />
          <Route path="/homework/5/question1" element={<Homework5Question1 />} />
          <Route path="/homework/5/question2" element={<Homework5Question2 />} />
          <Route path="/homework/6" element={<Homework6 />} />
          {/* <Route path="/homework/6/main" element={<Homework6Main />} /> */}
          <Route path="/homework/7" element={<Homework7 />} />
          <Route path="/homework/7/main" element={<Homework7Main />} />
          <Route path="/homework/8" element={<Homework8 />} />
          <Route path="/homework/9" element={<Homework9 />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
